import { bindActionCreators } from 'redux';
import React, { Component, useEffect } from 'react';
import { connect } from 'react-redux';
import { Row, Col, UncontrolledTooltip } from 'reactstrap';
import * as commonActions from '../../../app/common/common.action';
import * as kanbanActions from '../../../componentes/dragdrog/store/kanban.action';
import * as organizarActions from '../../../componentes/dragdrog/organizarLote/store/organizar.action';
import CitologiaPage from './citologia.page';
import WebapiCommon from '../../../app/common/util/webapi.common';
import CitologiaApi from './citologia.api';
import CommonFunctions from '../../../app/common/util/functions.common';
import cloneDeep from 'lodash/cloneDeep';
import { getUsuarioLocalStorage } from '../../../localStorage.util';
import { quadroKanbanEnum, colorsSystem } from '@common/util/defaultValues';
import Preview from '@componentes/PreviewURL';
import './citologia.styles.css';
import IntlMessage from "../../../helpers/intlMessage";
import { changePeriod, getDate, obterListagemDePeriodos, validarData } from '../../../helpers';
import {
	getOrdenacaoKanban,
	setOrdenacaoKanban,
  } from '../../../localStorage.util';

class CitologiaLaminasContainer extends Component {
	constructor(props) {
		super(props);
		this.usuario = getUsuarioLocalStorage();
		this.laudoRef = React.createRef();
		const periodo = CommonFunctions.getPeriodosSubDays(0);

		this.state = {
			tecnicos: [],
			tecnicoSelecionado: null,
			periodoInicial: periodo.periodoInicial,
			periodoFinal: periodo.periodoInicial,
			numeroDoExame: '',
			numeroDoPedido: '',
			laudoPesquisa: '',
			listaKanbam: this.getKanbam([], [], []),
			isShowModalAdicionarLamina: false,
			isShowModalEditarLamina: false,
			qtdLaminas: 0,
			complememtoLamina: '',
			complementos: [],
			patologistas: [],
			patologista: null,
			tecnico: null,
			laudo: '',
			laminaSelecionada: {},
			nr_exame: '',
			modalOpenNaoConfor: false,
			itemInModal: null,
			naoconformidades: [],
			modalOpenCancelar: false,
			itemInModalCancelar: null,
			justificativaParaCancelamento: '',
			exame: '',
			paciente: '',
			prontuario: '',
			blocosCitologia: [],
			blocoCitologia: null,
			laudoNaoExiste: true,
			dataInclusaoLamina: new Date().toISOString().slice(0, 10),
			showModalImprimirEtiquetaEmLote: false,
			showModalDelegacaoLaminas: false,
			laminasParaEtiqueta: [],
			laminaIndividualParaEtiqueta: null,
			showModalMapaMacroscopico: false,
			mudou: false,
			show: false,
			url: '',
			periodo: { value: 'hoje', label: `${this.props.intl.formatMessage({ id: "period.today" })}` },
			periodos: [],
			sortAsc: getOrdenacaoKanban(),
			gravarSugestaoComplementoCitologia : true,
			complementoNome : ''
		};
		this.numeroDoExameRef = React.createRef();
		this.getDate = getDate.bind(this);
		this.changePeriod = changePeriod.bind(this);
		this.obterListagemDePeriodos = obterListagemDePeriodos.bind(this);
		this.validarData = validarData.bind(this);
		this.periodoAlterado(this.state.periodo);
	}


	render() {
		const {
			tecnicos,
			messages,
			tecnicoSelecionado,
			periodoInicial,
			periodoFinal,
			numeroDoExame,
			laudoPesquisa,
			listaKanbam,
			isShowModalAdicionarLamina,
			isShowModalEditarLamina,
			laminaSelecionada,
			qtdLaminas,
			complememtoLamina,
			complementos,
			laudo,
			nr_exame,
			patologistas,
			patologista,
			tecnico,
			modalOpenNaoConfor,
			itemInModal,
			naoconformidades,
			modalOpenCancelar,
			itemInModalCancelar,
			justificativaParaCancelamento,
			exame,
			paciente,
			prontuario,
			blocosCitologia,
			blocoCitologia,
			laudoNaoExiste,
			dataInclusaoLamina,
			nConfInclusaoLamina,
			showModalImprimirEtiquetaEmLote,
			showModalDelegacaoLaminas,
			laminasParaEtiqueta,
			showModalMapaMacroscopico,
			numeroDoPedido
		} = this.state;

		const alturaKanbam = window.innerHeight - 191 + 'px';

		return (
			<div>
				<Preview
					show={this.state.show}
					setShow={this.setShow.bind(this)}
					url={this.state.url}
				/>
				<CitologiaPage
					limparFiltro={this.limparFiltro.bind(this)}
					history={this.props.history}
					usuario={this.props.usuario}
					tecnicos={tecnicos}
					tecnicoSelecionado={tecnicoSelecionado}
					periodoInicial={periodoInicial}
					periodoFinal={periodoFinal}
					numeroDoExame={numeroDoExame}
					laudoPesquisa={laudoPesquisa}
					listaKanbam={listaKanbam}
					isShowModalAdicionarLamina={isShowModalAdicionarLamina}
					isShowModalEditarLamina={this.state.isShowModalEditarLamina}
					qtdLaminas={qtdLaminas}
					complememtoLamina={complememtoLamina}
					complementos={complementos}
					setComplementos={this.setComplementos.bind(this)}
					laminaSelecionada={this.state.laminaSelecionada}
					laudo={laudo}
					nr_exame={nr_exame}
					patologistas={patologistas}
					patologista={patologista}
					tecnico={tecnico}
					alturaKanbam={alturaKanbam}
					modalOpenNaoConfor={modalOpenNaoConfor}
					itemInModal={itemInModal}
					naoconformidades={naoconformidades}
					usuarioLocal={this.usuario}
					modalOpenCancelar={modalOpenCancelar}
					itemInModalCancelar={itemInModalCancelar}
					justificativaParaCancelamento={justificativaParaCancelamento}
					onChangeData={this.onChangeData.bind(this)}
					onChangeTecnico={this.onChangeTecnico.bind(this)}
					onChangeNumeroExame={this.onChangeNumeroExame.bind(this)}
					onChangeLaudo={this.onChangeLaudo.bind(this)}
					onKeyPressNumeroExame={this.onKeyPressNumeroExame.bind(this)}
					onKeyPressLaudo={this.onKeyPressLaudo.bind(this)}
					onDragEndOverride={this.onDragEndOverride.bind(this)}
					botaoFlutuanteAdicionarLamina={this.botaoFlutuanteAdicionarLamina.bind(this)}
					showModalAdicionarLamina={this.showModalAdicionarLamina.bind(this)}
					showModalEditarLamina={this.botaoEditarLamina.bind(this)}
					alterarValorState={this.alterarValorState.bind(this)}
					adicionarLamina={this.adicionarLamina.bind(this)}
					toggleModalNaoConfor={this.toggleModalNaoConfor.bind(this)}
					toggleModalCancelar={this.toggleModalCancelar.bind(this)}
					apagarLaminaCitologia={this.apagarLaminaCitologia.bind(this)}
					callBackConclusaoInclusaoResolucaoNConformidade={this.callBackConclusaoInclusaoResolucaoNConformidade.bind(this)}
					preencherJustificativaParaCancelamento={this.preencherJustificativaParaCancelamento.bind(this)}
					handleCreateSelectCreatable={this.handleCreateSelectCreatable.bind(this)}
					numeroDoExameRef={this.numeroDoExameRef}
					exame={exame}
					paciente={paciente}
					prontuario={prontuario}
					blocosCitologia={blocosCitologia}
					blocoCitologia={blocoCitologia}
					laudoNaoExiste={laudoNaoExiste}
					dataInclusaoLamina={dataInclusaoLamina}
					nConfInclusaoLamina={nConfInclusaoLamina}
					laudoRef={this.laudoRef}
					showModalImprimirEtiquetaEmLote={showModalImprimirEtiquetaEmLote}
					toggleModalImprimirEtiquetaEmLote={this.toggleModalImprimirEtiquetaEmLote.bind(this)}
					showModalDelegacaoLaminas={showModalDelegacaoLaminas}
					toggleModalDelegacaoLaminas={this.toggleModalDelegacaoLaminas.bind(this)}
					laminasParaEtiqueta={laminasParaEtiqueta}
					imprimirEtiquetaIndividual={this.imprimirEtiquetaIndividual.bind(this)}
					imprimirEtiquetaEmLote={this.imprimirEtiquetaEmLote.bind(this)}
					showModalMapaMacroscopico={showModalMapaMacroscopico}
					toggleModalMapaMacroscopico={this.toggleModalMapaMacroscopico.bind(this)}
					pesquisaNumExame={this.pesquisaNumExame.bind(this)}
					limparCamposAdicionarLaminas={this.limparCamposAdicionarLaminas.bind(this)}
					buscar={this.buscar.bind(this)}
					organizar={this.organizar.bind(this)}
					onClickOrdem={this.onClickOrdem.bind(this)}
					sortAsc={this.state.sortAsc}
					setState={this.setState.bind(this)}
					commonActions={this.props.commonActions}
					periodos={this.state.periodos}
					periodo={this.state.periodo}
					onChangePeriodo={this.periodoAlterado.bind(this)}
					mudarIntervaloPeriodo={this.mudarIntervaloPeriodo.bind(this)}
					onKeyPressData={this.eventoOnKeyPressData.bind(this)}
					onKeyPressNumeroPedido={this.onKeyPressNumeroPedido.bind(this)}
					onChangeNumeroPedido={this.onChangeNumeroPedido.bind(this)}
					numeroDoPedido={numeroDoPedido}
				/>
			</div>
		);
	}

	componentDidMount() {
		this.props.commonActions.showFadeCarregando(true);
		Promise.all([
			WebapiCommon.getUsuarioTecnicoDaHistologia(),
			WebapiCommon.getMedicos(),
			WebapiCommon.getNaoConformidades(),
			WebapiCommon.listarComplemento('CITOLOGIA_TECNICA'),
			WebapiCommon.getConfiguracaoMapaMacroscopico(),
			WebapiCommon.getConfiguracoesGerais()
		]).then(res => {
			let state = { ...this.state };

			state.tecnicos = [{ value: null, label: <IntlMessage id="dashboards.cytology.technical" /> }, ...res[0]];
			state.tecnicoSelecionado = { value: null, label: <IntlMessage id="dashboards.cytology.technical" /> };
			state.patologistas = res[1];
			state.naoconformidades = res[2];
			state.complementos = res[3];
			state.gravarSugestaoComplementoCitologia = res[5].gravarSugestaoComplementoCitologia;

			let configMacro = res[4];
			if (configMacro) {
				let medicoPadrao = configMacro.configuracoesMapaMacroscopicoItems.find(
					el => el.coluna === 'Cd_med_padrao_macro'
				);

				if (medicoPadrao) {
					this.props.commonActions.medicoPadraoMacroscopia(medicoPadrao.valor);
				}
			}

			this.setState(state);

			this.filtrar(
				null,
				state.periodoInicial,
				state.periodoFinal,
				state.numeroDoExame,
				state.laudoPesquisa,
				state.numeroDoPedido,
				state.sortAsc,
			);
		});

		this.setState({periodos: this.obterListagemDePeriodos(this.props.intl)});
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.mudou) {
			this.setState({ mudou: false });
			this.buscar();
		}

		if (this.state.sortAsc !== prevState.sortAsc) {
			setOrdenacaoKanban(this.state.sortAsc);
			this.buscar();
		}

		if (this.props.novasLaminas) {
			this.props.kanbanActions.atualizarNovasLaminas(false);
			let data = CommonFunctions.getPeriodosSubDays();
			this.setState({
				periodoInicial: data.periodoInicial,
				periodoFinal: data.periodoFinal,
				mudou: true
			});
		}
		if (this.props.organizarLotenovasLaminas) {
			this.props.organizarActions.atualizarNovasLaminas(false);
			this.props.commonActions.showFadeCarregando(true);
			let data = CommonFunctions.getPeriodosSubDays();
			this.setState({
				periodoInicial: data.periodoInicial,
				periodoFinal: data.periodoFinal,
				mudou: true
			});
		}
	}

	resetarPeriodo = () => {
		this.setState({periodo: '', periodoInicial: null, periodoFinal: null})
	}

	periodoAlterado = (e) => {
		if (!e || !e.value) {
		  return this.resetarPeriodo();
		}

		let payload = this.getDate(e.value);
		payload.dtinicial = payload.dtinicial.toISOString().slice(0, 10);
		payload.dtfinal = payload.dtfinal.toISOString().slice(0, 10);

		this.setState({
			periodo: e,
			periodoInicial: payload.dtinicial,
			periodoFinal: payload.dtfinal})
	}

	mudarIntervaloPeriodo = (val) => {
		let payload = this.changePeriod(val);

		this.setState({
			periodoInicial: payload.start,
			periodoFinal: payload.end})
	}

	eventoOnKeyPressData(event) {
		if (event.key === "Enter")
			this.buscar();
	}

	buscar() {
		if ((!this.state.tecnicoSelecionado || this.state.tecnicoSelecionado.value == null) &&
			this.state.numeroDoExame == '' &&
			this.state.numeroDoPedido == '' &&
			this.state.laudoPesquisa == '' &&
			((this.state.periodoInicial == null) || this.state.periodoInicial == '') &&
			((this.state.periodoFinal == null) || this.state.periodoFinal == '')) {
				this.props.commonActions.showAlerta('alerta', this.props.intl.formatMessage({id: 'dashboards.general.noFilteredItems'}), 3000);
			return;
		}

		let executarValidacaoDeData =
			((this.state.periodoInicial != null) && this.state.periodoInicial != '') ||
			((this.state.periodoFinal != null) && this.state.periodoFinal != '');
		let datasValidas = !executarValidacaoDeData ? true :
			this.validarData(this.state.periodoInicial, this.state.periodoFinal, this.props.intl, this.props.commonActions);

		if (datasValidas) {
			this.props.commonActions.showFadeCarregando(true);
			this.filtrar(
				this.state.tecnicoSelecionado && this.state.tecnicoSelecionado.value,
				this.state.periodoInicial,
				this.state.periodoFinal,
				this.state.numeroDoExame,
				this.state.laudoPesquisa,
				this.state.numeroDoPedido,
				this.state.sortAsc
			);
		}
	}

	organizar() {
		this.props.organizarActions.atualizarModal(true);
	}

	onClickOrdem() {
		this.setState({sortAsc : !this.state.sortAsc});
	}

	limparFiltro() {
		this.setState({
			periodoInicial: null,
			periodoFinal: null,
			periodo: '',
			tecnicoSelecionado: null,
			numeroDoExame: '',
			numeroDoPedido: '',
			laudoPesquisa: '',
			listaKanbam: [],
			sortAsc : false
		});
	}

	onChangeData(name, value) {
		let state = { ...this.state };

		state[name] = value;
		this.setState(state);

		if (!value) {
			this.setState({ [name]: value });
		}
	}

	onChangeTecnico(tecnico) {
		let state = { ...this.state };
		state.tecnicoSelecionado = tecnico;
		this.setState(state);
		// this.props.commonActions.showFadeCarregando(true);
		// this.filtrar(
		// 	state.tecnicoSelecionado.value,
		// 	state.periodoInicial,
		// 	state.periodoFinal,
		// 	state.numeroDoExame,
		// 	state.laudoPesquisa
		// );
	}

	onChangeNumeroExame(event) {
		this.setState({
			numeroDoExame: event.currentTarget.value
		});
	}

	onChangeLaudo(event) {
		this.setState({
			laudoPesquisa: event.currentTarget.value
		});
	}

	onKeyPressNumeroExame(event) {
		if (event.key === 'Enter') {
			let {
				periodoInicial,
				periodoFinal,
				tecnicoSelecionado,
				numeroDoExame,
				laudoPesquisa,
				numeroDoPedido,
				sortAsc
			} = this.state;

			let tecnico = !!tecnicoSelecionado ? tecnicoSelecionado.value : null;
			this.props.commonActions.showFadeCarregando(true);
			this.filtrar(
				tecnico,
				periodoInicial,
				periodoFinal,
				numeroDoExame,
				laudoPesquisa,
				numeroDoPedido,
				sortAsc
			);
		}
	}

	onChangeNumeroPedido(event) {
		this.setState({
			numeroDoPedido: event.currentTarget.value
		});
	}

	onKeyPressNumeroPedido(event) {
		if (event.key === 'Enter') {
			let {
				periodoInicial,
				periodoFinal,
				tecnicoSelecionado,
				numeroDoExame,
				laudoPesquisa,
				numeroDoPedido,
				sortAsc
			} = this.state;

			let tecnico = !!tecnicoSelecionado ? tecnicoSelecionado.value : null;
			this.props.commonActions.showFadeCarregando(true);
			this.filtrar(
				tecnico,
				periodoInicial,
				periodoFinal,
				numeroDoExame,
				laudoPesquisa,
				numeroDoPedido,
				sortAsc
			);
		}
	}

	onKeyPressLaudo(event) {
		if (event.key === 'Enter') {
			let {
				periodoInicial,
				periodoFinal,
				tecnicoSelecionado,
				numeroDoExame,
				laudoPesquisa,
				numeroDoPedido,
				sortAsc
			} = this.state;

			let tecnico = !!tecnicoSelecionado ? tecnicoSelecionado.value : null;
			this.props.commonActions.showFadeCarregando(true);
			this.filtrar(
				tecnico,
				periodoInicial,
				periodoFinal,
				numeroDoExame,
				laudoPesquisa,
				numeroDoPedido,
				sortAsc
			);
		}
	}

	filtrar(tecnico, dataInicial, dataFinal, numeroDoExame, laudoPesquisa, numeroDoPedido, sortAsc) {
		WebapiCommon.getLaminasCitologia(
			tecnico,
			dataInicial,
			dataFinal,
			numeroDoExame,
			laudoPesquisa,
			numeroDoPedido,
			sortAsc
		).then(res => {
			let { listaKanbam } = this.state;

			let pendentes = res
				.filter(el => el.finalizacao === 'Pendente')
				.map(el =>
					this.criarItemKanbam(
						el,
						quadroKanbanEnum.CG_PENDENTES.icone,
						quadroKanbanEnum.CG_PENDENTES.id
					)
				);

			let executando = res
				.filter(el => el.finalizacao === 'Em andamento')
				.map(el =>
					this.criarItemKanbam(
						el,
						quadroKanbanEnum.CG_EXECUTANDO.icone,
						quadroKanbanEnum.CG_EXECUTANDO.id
					)
				);

			let concluidas = res
				.filter(el => el.finalizacao === 'Finalizado')
				.map(el =>
					this.criarItemKanbam(
						el,
						quadroKanbanEnum.CG_PRONTAS.icone,
						quadroKanbanEnum.CG_PRONTAS.id
					)
				);

			listaKanbam = this.getKanbam(pendentes, executando, concluidas);

			this.setState({
				listaKanbam,
				laminasParaEtiqueta: res
			});

			this.props.commonActions.showFadeCarregando(false);

			if (res.length === 0) {
				this.props.commonActions.showAlerta(
					'alerta',
					<IntlMessage id="dashboards.reports.noResultsFound" />,
					1500
				);
			}
		});
	}

	getKanbam(pendente, executando, concluidas) {
		return [
			{
				pendente: pendente,
				title: {
					text: <IntlMessage id="dashboards.cytology.danglingBlades" />,
					color: colorsSystem.DG2
				},
				count: pendente.length
			},
			{
				executando: executando,
				title: {
					text: <IntlMessage id="dashboards.cytology.bladesInProgress" />,
					color: colorsSystem.DG3
				},
				count: executando.length
			},
			{
				concluidas: concluidas,
				title: {
					text: <IntlMessage id="dashboards.cytology.bladesReady" />,
					color: colorsSystem.DG5
				},
				count: concluidas.length
			}
		];
	}

	criarItemKanbam(lamina, icone, etapa) {
		let id = `lamina_${lamina.idLamina}_${etapa}`;
		return {
			id: id,
			data: lamina,
			isDragDisabled: lamina.existeNConformidade === 1,
			content: this.templateHtmlItemKanbam(lamina, icone, id)
		};
	}

	templateHtmlItemKanbam(lamina, icone, id, /* props */) {

		// const {messages} = props.intl;

		return (
			<Row>
				<Col style={{ marginTop: '-10px' }}>
					<p style={{ fontSize: '16px', fontWeight: 600, marginBottom: '2px' }}>
						{lamina.lamina}
					</p>
					<p id={`exame_${id}`} style={{ fontSize: '14px', marginBottom: 0 }}>
						<strong><IntlMessage id="dashboards.examDetails.exam" /></strong>
						{lamina.exame.slice(0, 25)}
						{lamina.exame.length > 25 && '...'}
						{lamina.exame.length > 25 && (
							<UncontrolledTooltip placement='top' target={`exame_${id}`}>
								{lamina.exame}
							</UncontrolledTooltip>
						)}
					</p>
					<p
						id={`paciente_${id}`}
						style={{ fontSize: '14px', marginBottom: '2px' }}
						title={lamina.paciente}
					>
						<strong><IntlMessage id="dashboards.examDetail.patient" /></strong>
						{lamina.paciente}
					</p>
					{lamina.pacienteNomeSocial &&
						<p
							id={`nomesocial_${id}`}
							style={{ fontSize: '14px', marginBottom: '2px' }}
							title={lamina.pacienteNomeSocial}
						>
							<strong><IntlMessage id="dashboards.examDetails.socialName" /></strong>
							{lamina.pacienteNomeSocial}
						</p>
					}
					{lamina.complemento &&
						<p
							id={`complemento_${id}`}
							style={{ fontSize: '14px', marginBottom: '2px',  width: '80%' ,  whiteSpace: 'no-wrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
							title={lamina.complemento}
						>
							<strong><IntlMessage id="dashboards.examDetail.table.complement" /></strong>
							{`:  ${lamina.complemento}`}
						</p>
					}

				</Col>
				<div className='menu-right'>
					<div>
						{' '}
						<br></br>
						{(lamina.nConformidade === 'S' || lamina.existeNConformidade < 2) && (
							<div >
								<p
									id={`nao_conformidade${lamina.id}`}
									style={{ fontSize: '9px',  marginRight: '5px' }}
									className='badge badge-danger nao-conformidade'
								>
									<IntlMessage id='dashboards.general.nonCompliance' />
								</p>
							</div>

						)}
						<br></br>
						<p
							id={`data_atualizacao_${id}`}
							className='badge badge-info'
							style={{ fontSize: '10px', marginBottom: '5px' }}
						>
							{lamina.dataDeAtualizacao}
							<UncontrolledTooltip
								placement='top'
								target={`data_atualizacao_${id}`}
							>
								<IntlMessage id="dashboards.cytology.updateDate" />
							</UncontrolledTooltip>
						</p>
						<div className='menu-card-right'>
							<i
								style={{ marginRight: '8px' }}
								className='mv-basico-codigo_barras'
								onClick={() => {
									this.imprimirEtiquetaIndividual(lamina);
								}}
							></i>
							<i
								style={{ marginRight: '8px' }}
								className='fas fa-trash-alt'
								// title={messages['dashboards.examDetails.cancel']}
								onClick={() => {
									this.openModalCancelar(lamina);
								}}
							></i>
							<i
								className='fas fa-exclamation-circle'
								style={{ color: `${(lamina.existeNConformidade !== 2) ? 'red' : ''}` }}
								title={`${this.props.intl.formatMessage({ id: 'dashboards.general.nonCompliance' })}`}
								onClick={() => this.openModalNaoConformidade(lamina)}
							></i>

						</div>
						<i
							className={`${icone} fa-2x`}
							style={{
								color: colorsSystem.DG1,
								fontSize: '1.5em',
								marginRight: '8px'
							}}
						></i>
						<i
							className='fas fa-pen'
							style={{
								color: colorsSystem.DG1,
								fontSize: '0.5rem'
							}}
							onClick={() => {
								console.log(lamina)
								this.setState({
									laminaSelecionada: lamina
								})
								console.log(this.state.laminaSelecionada)
								this.botaoEditarLamina()
							}}
						></i>
					</div>
				</div>
			</Row>
		);
	}

	openModalNaoConformidade(lamina) {
		let coluna = '';
		coluna = lamina.nmTabela === 'LAUDOLAMINAS' ? 'laudo_lamina' : coluna;
		coluna = lamina.nmTabela === 'LAUDOBLOCOSLAMINAS' ? 'bloco_lamina' : coluna;

		this.setState({
			itemInModal: {
				id: lamina.idExterno,
				label: lamina.lamina,
				etapa: 3,
				idExame: lamina.idExame,
				idLaudo: lamina.laudo,
				coluna
			}
		});

		this.toggleModalNaoConfor();
	}

	openModalCancelar(lamina) {
		this.setState({
			itemInModalCancelar: {
				idExterno: lamina.idExterno,
				label: lamina.lamina,
				laudo: lamina.laudo
			}
		});

		this.toggleModalCancelar();
	}

	onDragEndOverride(result) {
		const { source, destination } = result;

		var origem = {
			pendente: 0,
			executando: 1,
			concluidas: 2
		};

		let { listaKanbam } = this.state;

		let item =
			listaKanbam[origem[source.droppableId]][source.droppableId][source.index];
		let error =
			item.data.bloqueado === 'S'
				? <IntlMessage id="dashboards.immunology.blockedImpedingNonconformity" />
				: '';

		error = !(source && destination) ? <IntlMessage id="dashboards.immunology.unexpectedErrorOccurred" /> : '';

		if (error === '') {
			this.move(source, destination);
		} else {
			this.props.commonActions.showAlerta('erro', error, 2000);
		}
	}

	move(source, destination) {
		let listaKanbam = cloneDeep(this.state.listaKanbam);
		let origem = listaKanbam.find(
			e => Object.keys(e)[0] === source.droppableId
		);
		let destino = listaKanbam.find(
			e => Object.keys(e)[0] === destination.droppableId
		);
		let movido = origem[source.droppableId].splice(source.index, 1)[0];

		let icone = quadroKanbanEnum.CG_PENDENTES.icone;
		icone =
			destination.droppableId === quadroKanbanEnum.CG_EXECUTANDO.id
				? quadroKanbanEnum.CG_EXECUTANDO.icone
				: icone;
		icone =
			destination.droppableId === quadroKanbanEnum.CG_PRONTAS.id
				? quadroKanbanEnum.CG_PRONTAS.icone
				: icone;

		let status = quadroKanbanEnum.CG_PENDENTES.status;
		status =
			destination.droppableId === quadroKanbanEnum.CG_EXECUTANDO.id
				? quadroKanbanEnum.CG_EXECUTANDO.status
				: status;
		status =
			destination.droppableId === quadroKanbanEnum.CG_PRONTAS.id
				? quadroKanbanEnum.CG_PRONTAS.status
				: status;

		WebapiCommon.atualizarStatusDaLamina(movido.data.idLamina, status)
			.then(() => {
				destino[destination.droppableId].splice(
					destination.index,
					0,
					this.criarItemKanbam(movido.data, icone)
				);
				destino[destination.droppableId] = destino[
					destination.droppableId
				].sort((a, b) => {
					return a.data.idLamina - b.data.idLamina;
				});

				listaKanbam[0]['count'] =
					listaKanbam[0][quadroKanbanEnum.CG_PENDENTES.id].length;
				listaKanbam[1]['count'] =
					listaKanbam[1][quadroKanbanEnum.CG_EXECUTANDO.id].length;
				listaKanbam[2]['count'] =
					listaKanbam[2][quadroKanbanEnum.CG_PRONTAS.id].length;

				this.setState({ listaKanbam });
				this.props.commonActions.showAlerta(
					'sucesso',
					<IntlMessage id="dashboards.cytology.poweredBlades" />,
					800
				);
			})
			.catch(err => {
				console.log(err);
				this.props.commonActions.showAlerta(
					'erro',
					<IntlMessage id="dashboards.cytology.bladesNotMoved" />,
					1500
				);
			});
	}

	botaoFlutuanteAdicionarLamina() {
		this.showModalAdicionarLamina();
	}

	botaoEditarLamina() {
		this.setState({
			isShowModalEditarLamina: !this.state.isShowModalEditarLamina
		});
	}

	showModalAdicionarLamina() {
		let state = { ...this.state };

		state.isShowModalAdicionarLamina = !state.isShowModalAdicionarLamina;
		state.qtdLaminas = 0;
		state.complememtoLamina = '';
		state.patologista = null;

		if (this.props.medicoPadrao !== null) {
			let encontrouMedico = state.patologistas.find(
				el => el.value === this.props.medicoPadrao
			);
			if (encontrouMedico) {
				state.patologista = encontrouMedico;
			}
		}

		state.tecnico = {
			label: this.usuario.usuarioId + ' - ' + this.usuario.usuario,
			value: this.usuario.usuarioId
		};

		state.laudo = '';
		state.nr_exame = '';
		state.prontuario = '';
		state.paciente = '';
		state.exame = '';
		state.laudoNaoExiste = true;
		state.blocosCitologia = [];
		state.blocoCitologia = null;
		state.nConfInclusaoLamina = null;

		this.setState(state);
	}

	alterarValorState(propName, valor) {
		let state = { ...this.state };
		state[propName] = valor;
		this.setState(state);
	}

	setComplementos(complementos) {
		let state = { ...this.state };
		state.complementos = complementos;
		this.setState(state);
	}

	pesquisaNumExame(numeroExame) {
		this.props.commonActions.showFadeCarregando(true);
		CitologiaApi.obterInfoLaudoNovaLaminaCitologia(
			encodeURIComponent(numeroExame)
		).then(res => {
			let result = res.data;
			let state = { ...this.state };

			if (result !== null) {
				state.laudo = result.laudo;
				state.laudoNaoExiste = false;
				state.exame = result.exame;
				state.paciente = result.paciente;
				state.prontuario = result.prontuario;

				if (result.blocosCitologias !== undefined) {
					state.blocosCitologia = result.blocosCitologias.map(el => ({
						label: el.numeroBloco,
						value: el.idLaudoBloco
					}));
				}
			} else {
				state.exame = '';
				state.nr_exame = '';
				state.paciente = '';
				state.prontuario = '';
				state.blocosCitologia = [];
				state.blocoCitologia = null;
				state.laudoNaoExiste = true;
			}

			this.setState(state);
			this.props.commonActions.showFadeCarregando(false);
		});
	}

	adicionarLamina() {
		let {
			qtdLaminas,
			complememtoLamina,
			patologista,
			laudo,
			tecnico,
			nConfInclusaoLamina,
			blocoCitologia,
			complementoNome,
			gravarSugestaoComplementoCitologia
		} = this.state;
		debugger;
		let laminaCitologiaRequest = {
			laudo: laudo,
			quantidade: qtdLaminas,
			// complemento: gravarSugestaoComplementoCitologia? complememtoLamina.label : complementoNome ,
			complemento: complememtoLamina.label,
			idUsuarioLogado: this.usuario.usuarioId,
			idMedicoPatologista: null,
			idTecnico: null,
			nomeMedicoPatologista: '',
			nomeTecnico: '',
			idNConf: null,
			cdBloco: null
		};

		if (patologista) {
			laminaCitologiaRequest.idMedicoPatologista = patologista.value;
			laminaCitologiaRequest.nomeMedicoPatologista = patologista.label;
		}

		if (tecnico) {
			laminaCitologiaRequest.idTecnico = tecnico.value;
			laminaCitologiaRequest.nomeTecnico = tecnico.label;
		}

		if (nConfInclusaoLamina) {
			laminaCitologiaRequest.idNConf = nConfInclusaoLamina.value;
		}

		if (blocoCitologia) {
			laminaCitologiaRequest.cdBloco = blocoCitologia.value;
		}

		this.props.commonActions.showFadeCarregando(true);

		CitologiaApi.adicionarLaminaDeCitologia(laminaCitologiaRequest).then(
			res => {
				if (res.success) {
					let state = { ...this.state };
					let tecnico = !!state.tecnicoSelecionado
						? state.tecnicoSelecionado.value
						: null;
					this.showModalAdicionarLamina();
					this.filtrar(
						tecnico,
						state.periodoInicial,
						state.periodoFinal,
						state.numeroDoExame,
						state.laudoPesquisa,
						state.numeroDoPedido,
						state.sortAsc
					);

					this.props.commonActions.showAlerta(
						'sucesso',
						res.message,
						2000,
						res.message.length * 10 + 'px'
					);
				} else {
					this.props.commonActions.showFadeCarregando(false);
					this.props.commonActions.showAlerta(
						'erro',
						res.message,
						2000,
						res.message.length * 10 + 'px'
					);
				}
			}
		);
	}

	toggleModalNaoConfor = () =>
		this.setState(state => ({
			modalOpenNaoConfor: !state.modalOpenNaoConfor
		}));

	toggleModalCancelar = () =>
		this.setState(state => ({
			modalOpenCancelar: !state.modalOpenCancelar,
			justificativaParaCancelamento: ''
		}));

	apagarLaminaCitologia() {
		let state = { ...this.state };

		this.props.commonActions.showFadeCarregando(true);

		CitologiaApi.apagarLaminaDeCitologia(
			state.itemInModalCancelar.laudo,
			state.itemInModalCancelar.idExterno,
			state.justificativaParaCancelamento
		).then(res => {
			if (res.success) {
				let tecnico = !!state.tecnicoSelecionado
					? state.tecnicoSelecionado.value
					: null;
				this.toggleModalCancelar();
				this.filtrar(
					tecnico,
					state.periodoInicial,
					state.periodoFinal,
					state.numeroDoExame,
					state.laudoPesquisa,
					state.numeroDoPedido,
					state.sortAsc
				);
				this.props.commonActions.showAlerta(
					'sucesso',
					res.message,
					2000,
					res.message.length * 10 + 'px'
				);
			} else {
				this.props.commonActions.showFadeCarregando(false);
				this.props.commonActions.showAlerta(
					'erro',
					res.message,
					2000,
					res.message.length * 10 + 'px'
				);
			}
		});
	}

	callBackConclusaoInclusaoResolucaoNConformidade() {
		let state = { ...this.state };
		this.props.commonActions.showFadeCarregando(true);
		let tecnico = !!state.tecnicoSelecionado
			? state.tecnicoSelecionado.value
			: null;
		this.filtrar(
			tecnico,
			state.periodoInicial,
			state.periodoFinal,
			state.numeroDoExame,
			state.laudoPesquisa,
			state.numeroDoPedido,
			state.sortAsc
		);
	}

	obterPeriodoFiltroInicializacao() {
		return CommonFunctions.getPeriodosSubDays(0);
	}

	preencherJustificativaParaCancelamento = event =>
		this.setState({
			justificativaParaCancelamento: event.currentTarget.value
		});

	handleCreateSelectCreatable = value => {
		const etapa = 'CITOLOGIA_TECNICA';
		this.props.commonActions.showFadeCarregando(true);

		if (this.state.gravarSugestaoComplementoCitologia) {
			WebapiCommon.cadastrarComplemento(etapa, value).then(() => {
				WebapiCommon.listarComplemento(etapa).then(res => {
					let state = { ...this.state };
					this.setState({
						complementos: res,
						complememtoLamina: res.find(el => el.label === value)
					})
					this.props.commonActions.showFadeCarregando(false);
				});
			});
		}
		else
		{
			WebapiCommon.listarComplemento(etapa).then(res => {
				var novoComplemento = {label: value, value: 0};
				let complementos = res;
				complementos.push(novoComplemento);
				this.setState({
					complementos: complementos,
					complememtoLamina: novoComplemento
				});
				this.props.commonActions.showFadeCarregando(false);
			});
		}
	};

	toggleModalImprimirEtiquetaEmLote = () =>
		this.setState(state => ({
			showModalImprimirEtiquetaEmLote: !state.showModalImprimirEtiquetaEmLote
		}));

	toggleModalDelegacaoLaminas = () =>
		this.setState(state => ({
			showModalDelegacaoLaminas: !state.showModalDelegacaoLaminas
		}));

	toggleModalMapaMacroscopico = () => {
		const {
			showModalMapaMacroscopico,
			tecnicoSelecionado,
			periodoInicial,
			periodoFinal,
			numeroDoExame,
			laudoPesquisa,
			numeroDoPedido,
			sortAsc
		} = this.state;

		if (showModalMapaMacroscopico) {
			let tecnico = !!tecnicoSelecionado ? tecnicoSelecionado.value : null;
			this.filtrar(
				tecnico,
				periodoInicial,
				periodoFinal,
				numeroDoExame,
				laudoPesquisa,
				numeroDoPedido,
				sortAsc
			);
		}

		this.setState({
			showModalMapaMacroscopico: !showModalMapaMacroscopico
		});
	};

	imprimirEtiquetaIndividual(item) {
		this.props.commonActions.showFadeCarregando(true);
		let etiquetas = [];

		etiquetas.push({
			impressora: 'clawPDF',
			codigoBarra: item.lamina,
			numeroExame: item.numeroExame,
			numeroAtendimento: item.laudo.toString(),
			numeroPedido: item.numeroPedido.toString(),
			nomePaciente: item.paciente,
			complemento: item.complemento,
			modelo: 'areatecnica'
		});

		WebapiCommon.imprimirEtiquetaAreaTecnica(etiquetas).then(data => {
			var url = CommonFunctions.getPdfBlob(data.pdf);
			this.props.commonActions.showFadeCarregando(false);
			this.setState({ url: url });
			this.setShow(!this.state.show);
		});
	}

	imprimirEtiquetaEmLote(laminasMarcadas) {
		this.props.commonActions.showFadeCarregando(true);
		let laminas = [];

		laminasMarcadas.map(el => {
			let laminasParaEtiqueta = this.state.laminasParaEtiqueta;
			let lamina = laminasParaEtiqueta.find(la => la.idLamina === el);

			laminas.push({
				impressora: 'clawPDF',
				codigoBarra: lamina.lamina,
				numeroExame: lamina.numeroExame,
				numeroAtendimento: lamina.laudo.toString(),
				numeroPedido: lamina.numeroPedido.toString(),
				nomePaciente: lamina.paciente,
				complemento: lamina.complemento,
				modelo: 'areatecnica'
			});
		});
		WebapiCommon.imprimirEtiquetaAreaTecnica(laminas).then(data => {
			var url = CommonFunctions.getPdfBlob(data.pdf);
			this.props.commonActions.showFadeCarregando(false);
			this.setState({ url: url });
			this.setShow(!this.state.show);
		});
	}

	setShow(show) {
		this.setState({ show });

		if (!show && this.state.showModalImprimirEtiquetaEmLote) {
			this.toggleModalImprimirEtiquetaEmLote();
		}
	}

	limparCamposAdicionarLaminas = () =>
		this.setState({
			qtdLaminas: 0,
			complememtoLamina: '',
			patologista: null,
			tecnico: null,
			laudo: '',
			nr_exame: '',
			prontuario: '',
			paciente: '',
			exame: '',
			laudoNaoExiste: true,
			blocosCitologia: [],
			blocoCitologia: null
		});
}

const mapStateToProps = state => {
	return {
		usuario: state.usuario,
		novasLaminas: state.kanban.novasLaminas,
		medicoPadrao: state.commonReducer.medicoPadraoMacroscopia,
		organizarLotenovasLaminas: state.organizarLote.novasLaminas
	};
};

const mapDispatchToProps = dispatch => {
	return {
		commonActions: bindActionCreators(commonActions, dispatch),
		kanbanActions: bindActionCreators(kanbanActions, dispatch),
		organizarActions: bindActionCreators(organizarActions, dispatch)
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CitologiaLaminasContainer);



// WEBPACK FOOTER //
// ./src/pages/citologia/content/citologia.container.js